import React, { Component } from "react";
import { Grid, Cell } from "react-mdl";
import logo from "../Components/logo.png";
import Animation from "../Components/animation";

class Landing extends Component {
  render() {
    return (
      <div style={{ width: "auto", margin: "auto" }}>
        <Grid className="landing-grid">
          <Cell col={12}>
            <img className="avatar-img" src={logo} alt="logo" />
            <div className="banner-text">
              <h1>FULL STACK WEB DEVELOPER</h1>
              <hr />
              <p>HTML5 / CSS3 | BOOTSTRAP | REACT JS | WORDPRESS</p>
              <div className="social-links">
                <Animation />
                {/*Linkdin */}
                <a
                  href="https://www.linkedin.com/in/hicham-fatih-6ba462151/"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <i class="fa fa-linkedin-square" aria-hidden="true" />
                </a>
                {/*Github */}
                <a
                  href="https://github.com/FatihHicham"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <i class="fa fa-github-square" aria-hidden="true" />
                </a>
                {/*Gitlab */}
                <a
                  href="https://gitlab.com/Hixam"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <i class="fa fa-gitlab" aria-hidden="true" />
                </a>
                {/*Youtube */}
                <a
                  href="https://www.youtube.com/channel/UCVKSQovJTQXrtKIIFhpeKNQ?view_as=subscriber"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <i class="fa fa-youtube-square" aria-hidden="true" />
                </a>
              </div>
            </div>
          </Cell>
        </Grid>
      </div>
    );
  }
}
export default Landing;
